import { FC, ReactNode } from 'react';
import { cvaPageWrapper } from '~/shared/ui/PageWrapper/PageWrapperStyles';
import clsx from 'clsx';
import { cubicBezier, motion } from 'framer-motion';

interface Props {
  children: ReactNode;
  noScroll?: boolean;
  className?: string;
  variant?: 'own' | 'secondary' | 'third';
  height?: 'full' | 'fit';
  animation?: boolean;
}

export const PageWrapper: FC<Props> = ({
  children,
  noScroll,
  className,
  variant,
  height,
  animation = true,
}) => {
  return (
    <motion.div
      transition={{
        ease: cubicBezier(0.55, 0.055, 0.675, 0.19),
        duration: 0.2,
      }}
      animate={{ opacity: 1 }}
      initial={{ opacity: animation ? 0 : 1 }}
      className={clsx(
        cvaPageWrapper({
          noScroll,
          height: height ? height : 'full',
          size: variant ? variant : 'own',
        }),
        className
      )}>
      {children}
    </motion.div>
  );
};
